<script setup lang="ts">
import BatchTypeHeader from '@/components/features/batches/tab-content/BatchTypeHeader.vue'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import { RouterLink } from 'vue-router'
import { Icon } from '@iconify/vue'
import { formatedDate } from '@/constants'
import { getSupplierList } from '@/api/suppliers'
import type { Supplier } from '@/types/supplier-types'
import { onMounted, ref } from 'vue'
import type { Product } from '@/types/product-types'
import { getProductList } from '@/api/products'
import { getUnfinishedProduct } from '@/constants/productSpecification'


const props = defineProps<{
  batchList: any
}>()
const products = ref<Product[]>([])

onMounted(async () => {
  products.value = await getProductList()
})


</script>

<template>
  <BatchTypeHeader
    title="Greig"
    description="Find all batches still in Greig state here."
  />

  <DataTable :value="batchList" class="px-0">
    <Column field="batchNumber" header="Batch Number">
      <template #body="slotProps">
        <RouterLink
          :to="`/batches/${slotProps.data.id}`"
          class="font-medium text-neutral-800 block hover:underline"
        >
          {{ slotProps.data.batchNumber }}
        </RouterLink>
      </template>
    </Column>
    <Column field="knittingQualityId" header="Batch Quality">
      <template #body="slotProps">
        <RouterLink
            :to="`/productSpecification/${slotProps.data.knittingQualityId}`"
            class="font-medium text-neutral-800 block hover:underline"
        >
          {{ getUnfinishedProduct(slotProps.data.knittingQualityId, products) }}
        </RouterLink>
      </template>
    </Column>
    <Column field="dateKnitted" header="Date Entered">
      <template #body="slotProps">
        <span>{{ formatedDate(slotProps.data.dateKnitted) }}</span>
      </template>
    </Column>
    <Column field="rolls.length" header="Number of Rolls"/>
    <Column field="action">
      <template #body="slotProps">
        <RouterLink
          :to="`/batches/${slotProps.data.id}`"
          class="flex items-center gap-x-2 group hover:text-primary-default"
        >
          <span> More Details</span>
          <Icon
            icon="material-symbols:more-up"
            class="text-2xl group-hover:translate-x-2 transition-transform text-primary-500"
          />
        </RouterLink>
      </template>
    </Column>
  </DataTable>
</template>